<!-- 全球覆盖网络 -->
<template>
  <div class="e_world">
    <div class="fullBg" :style="{backgroundImage:'url('+ bgUrl +')'}">
      <div class="fullText">
        <ul>
          <li>
            <img :src="baseImgUrl + '/u/20230101/local@2x_1672573902608.png'" />
            <strong class="number">99.999%</strong>
            <p>Uptime</p>
          </li>
          <li>
            <img :src="baseImgUrl + '/u/20230101/time@2x_1672573902609.png'" />
            <strong class="number">50+</strong>
            <p>International Data Center</p>
          </li>
          <li>
            <img :src="baseImgUrl + '/u/20230101/uptime@2x_1672573902610.png'" />
            <strong class="number">100+</strong>
            <p>Corporate Customers</p>
          </li>
          <li>
            <img :src="baseImgUrl + '/u/20230101/user@2x_1672573902611.png'" />
            <strong class="number">24x7x365</strong>
            <p>
              Full time service
              <br />
            </p>
          </li>
        </ul>
      </div>
    </div>
    <div class="styleBox_03">
      <img :src="baseImgUrl + '/u/20230101/new-Map备份_1672573817040.png'" />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      baseImgUrl: '',
      bgUrl: ''
    }
  },
  methods: {
  },
  created () {
  },
  mounted () {
    this.baseImgUrl = this.$axios.defaults.baseURL
    this.bgUrl = this.$axios.defaults.baseURL + '/u/20230101/img_bg_1672573758520.jpg'
  },
  computed: {
  }
}
</script>
<style lang="less" scoped>
@media only screen and (max-width: 1024px) {
  .fullBg {
    width: 100%;
    overflow: hidden;
    position: relative;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    transition: all 0.4s;
    -moz-transition: all 0.4s;
    -webkit-transition: all 0.4s;
    -o-transition: all 0.4s;
  }

  .fullText {
    width: 100%;
    max-width: 1180px;
    margin: 0 auto;
    position: relative;
    z-index: 9;
    padding-top: 3rem;
    box-sizing: border-box;
  }

  .fullText ul {
    display: flex;
    justify-content: space-around;
    flex-wrap: wrap;
  }

  .fullText ul li {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    width: 50%;
    margin-bottom: 3.375rem;
  }

  .fullText ul li img {
    width: 4.375rem;
    height: 4.375rem;
    margin-bottom: 0.625rem;
    transition: all 0.4s;
    -moz-transition: all 0.4s;
    -webkit-transition: all 0.4s;
    -o-transition: all 0.4s;
  }

  .fullText ul li strong {
    font-size: 1.375rem;
    font-weight: 600;
    color: #ffffff;
    transition: all 0.4s;
    -moz-transition: all 0.4s;
    -webkit-transition: all 0.4s;
    -o-transition: all 0.4s;
  }

  .fullText ul li p {
    font-size: 0.875rem;
    font-weight: 500;
    color: #ffffff;
    transition: all 0.4s;
    -moz-transition: all 0.4s;
    -webkit-transition: all 0.4s;
    -o-transition: all 0.4s;
  }

  .fullText ul li:hover img {
    transform: scale(0.6);
  }

  .fullText ul li:hover strong {
    transform: scale(1.2) translateY(-16px);
  }

  .fullText ul li:hover p {
    transform: scale(1.1) translateY(-16px);
  }

  .fullBg:hover {
    background-size: 102% 102%;
  }

  .styleBox_03 {
    width: 100%;
    text-align: center;
  }

  .styleBox_03 img {
    width: 100%;
    max-width: 1080px;
  }
}

@media only screen and (min-width: 1024px) {
  .fullBg {
    width: 100%;
    height: 492px;
    overflow: hidden;
    position: relative;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    transition: all 0.4s;
    -moz-transition: all 0.4s;
    -webkit-transition: all 0.4s;
    -o-transition: all 0.4s;
  }

  .fullText {
    max-width: 1180px;
    margin: 0 auto;
    position: relative;
    z-index: 9;
    padding-top: 98px;
    box-sizing: border-box;
  }

  .fullText ul {
    display: flex;
    justify-content: space-around;
  }

  .fullText ul li {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    cursor: pointer;
  }

  .fullText ul li img {
    width: 100px;
    height: 100px;
    margin-bottom: 20px;
    transition: all 0.4s;
    -moz-transition: all 0.4s;
    -webkit-transition: all 0.4s;
    -o-transition: all 0.4s;
  }

  .fullText ul li strong {
    font-size: 40px;
    font-weight: 600;
    color: #ffffff;
    line-height: 56px;
    transition: all 0.4s;
    -moz-transition: all 0.4s;
    -webkit-transition: all 0.4s;
    -o-transition: all 0.4s;
  }

  .fullText ul li p {
    font-size: 20px;
    font-weight: 500;
    color: #ffffff;
    line-height: 28px;
    transition: all 0.4s;
    -moz-transition: all 0.4s;
    -webkit-transition: all 0.4s;
    -o-transition: all 0.4s;
  }

  .fullText ul li:hover img {
    transform: scale(0.6);
  }

  .fullText ul li:hover strong {
    transform: scale(1.5) translateY(-16px);
  }

  .fullText ul li:hover p {
    transform: scale(1.3) translateY(-16px);
  }

  .fullBg:hover {
    background-size: 102% 102%;
  }

  .styleBox_03 {
    width: 100%;
    margin-top: -130px;
    position: relative;
    z-index: 8;
    text-align: center;
  }

  .styleBox_03 img {
    width: 100%;
    max-width: 1080px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/comForPc/English_model/E_world.vue